import React from 'react'
import { Pressable, View } from 'react-native'
import { Card } from 'react-native-paper'
import { createStyle } from '../../../contexts/global-styles.provider'

interface CardLayoutProps {
  onPress?: () => void
  children: React.ReactNode
  style?: any
}

export const CardLayout = ({ onPress, children, style }: CardLayoutProps) => {
  const styles = useStyle()

  return (
    <Pressable onPress={onPress}>
      <Card style={[styles.card, style]}>
        <View style={styles.content}>{children}</View>
      </Card>
    </Pressable>
  )
}

const useStyle = createStyle(({ theme }) => ({
  card: {
    margin: theme.spacing(2),
    padding: theme.spacing(3),
    elevation: 2,
  },
  content: {
    flex: 1,
  },
}))
